import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
const originalPush = VueRouter.prototype.push;
const flag = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);
const postId = localStorage.getItem("iuPost")*1;
console.log(postId);
var path = "";
if (postId == 3) {
  console.log('111');
  path = "/Home/applicant";
} else if (postId == 4) {
  path = "/Home/BackTone";
} else {
  path = "/Home/recording";
}
if (flag) {
  path =
    postId == 3
      ? "/Home/applicant"
      : postId == 4
      ? "/Home/BackTone"
      : "/Home/recordingh5";
}
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
console.log(path);

Vue.use(VueRouter);
//console.log(flag);
const routes = [
  {
    path: "",
    redirect: "/dologin",
  },

  {
    path: "/dologin",
    name: "dologin",
    component: () => import("../views/doLogin.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/loading",
    name: "loadingPage",
    component: () => import("../views/loadingPage/loadingPage.vue"),
    meta: {
      title: "加载中",
    },
  },

  {
    path: "/Home",
    name: "Home",
    component: () => import("../views/Home.vue"),
    children: [
      {
        path: "",
        redirect: path,
      },

      {
        path: "userList",
        name: "userList",
        component: () => import("../views/user/userList"),
      },
      {
        path: "authority",
        name: "authority",
        component: () => import("../views/authority/authority"),
      },
      {
        path: "SystemLog",
        name: "SystemLog",
        component: () => import("../views/SystemLog/SystemLog"),
      },

      {
        path: "recording",
        name: "recording",
        component: () => import("../views/recording/recording"),
      },
      {
        path: "recordingh5",
        name: "recordingh5",
        component: () => import("../views/recordingh5.vue"),
      },
      {
        path: "channel",
        name: "channel",
        component: () => import("../views/interview/channel.vue"),
      },
      {
        path: "applicant",
        name: "applicant",
        component: () => import("../views/interview/applicant.vue"),
      },
      {
        path: "applicantTwo",
        name: "applicantTwo",
        component: () => import("../views/interview/applicantTwo.vue"),
      },
      {
        path: "applicantQuery",
        name: "applicantQuery",
        component: () => import("../views/interview/applicantQuery.vue"),
      },
      {
        path: "dateWeek",
        name: "dateWeek",
        component: () => import("../views/dateWeek/dateWeek.vue"),
      },
      {
        path: "recruitmentAnalysis",
        name: "recruitmentAnalysis",
        component: () =>
          import("../views/recruitmentAnalysis/recruitmentAnalysis.vue"),
      },
      {
        path: "Roster",
        name: "Roster",
        component: () => import("../views/Roster/Roster.vue"),
      },
      {
        path: "errorApi",
        name: "errorApi",
        component: () => import("../views/journal/errorApi.vue"),
      },
      {
        path: "newTopicAnswer",
        name: "newTopicAnswer",
        component: () => import("../views/bank/newTopicAnswer.vue"),
      },
      {
        path: "topicAnswer",
        name: "topicAnswer",
        component: () => import("../views/bank/topicAnswer.vue"),
      },
      {
        path: "TestGrouping",
        name: "TestGrouping",
        component: () => import("../views/bank/TestGrouping.vue"),
      },
      {
        path: "personalityTest",
        name: "personalityTest",
        component: () => import("../views/personalityTest/personalityTest.vue"),
      },
      {
        path: "personalityTest",
        name: "personalityTest",
        component: () => import("../views/personalityTest/personalityTest.vue"),
      },
      {
        path: "RosterHand",
        name: "RosterHand",
        component: () => import("../views/Roster/RosterHand.vue"),
      },
      {
        path: "talentPool",
        name: "talentPool",
        component: () => import("../views/talentPool/talentPool.vue"),
      },
      {
        path: "wxFeedBack",
        name: "wxFeedBack",
        component: () => import("../views/wxFeedBack/wxFeedBack.vue"),
      },
      {
        path: "wxColophon",
        name: "wxColophon",
        component: () => import("../views/wxColophon/wxColophon.vue"),
      },
      {
        path: "wxMemoryBaseAddress",
        name: "wxMemoryBaseAddress",
        component: () =>
          import("../views/wxMemoryBaseAddress/wxMemoryBaseAddress.vue"),
      },
      {
        path: "wxErrorLog",
        name: "wxErrorLog",
        component: () => import("../views/wxErrorLog/wxErrorLog.vue"),
      },
      {
        path: "wxToolLog",
        name: "wxToolLog",
        component: () => import("../views/wxToolLog/wxToolLog.vue"),
      },
      {
        path: "ShareCustomersSj",
        name: "ShareCustomersSj",
        component: () => import("../views/ShareCustomers/ShareCustomersSj"),
      },
      {
        path: "ShareCustomersToken",
        name: "ShareCustomersToken",
        component: () => import("../views/ShareCustomers/ShareCustomersToken"),
      },
      {
        path: "ShareCustomersXcb",
        name: "ShareCustomersXcb",
        component: () => import("../views/ShareCustomers/ShareCustomersXcb"),
      },
      {
        path: "ShareCustomersZc",
        name: "ShareCustomersZc",
        component: () => import("../views/ShareCustomers/ShareCustomersZc"),
      },
      {
        path: "ShareCustomersFileList",
        name: "ShareCustomersFileList",
        component: () =>
          import("../views/ShareCustomers/ShareCustomersFileList"),
      },
      {
        path: "ShareCustomersNQ",
        name: "ShareCustomersNQ",
        component: () => import("../views/ShareCustomers/ShareCustomersNQ"),
      },
      {
        path: "ShareCustomersMK",
        name: "ShareCustomersMK",
        component: () => import("../views/ShareCustomers/ShareCustomersMK"),
      },
      {
        path: "DDingUser",
        name: "DDingUser",
        component: () => import("../views/ShareCustomers/DDingUser"),
      },
      {
        path: "DDingLeave",
        name: "DDingLeave",
        component: () => import("../views/ShareCustomers/DDingLeave"),
      },
      {
        path: "DDingDepartment",
        name: "DDingDepartment",
        component: () => import("../views/ShareCustomers/DDingDepartment"),
      },
      {
        path: "videoList",
        name: "videoList",
        component: () => import("../views/videoList/videoList.vue"),
      },
      {
        path: "onlineDes",
        name: "onlineDes",
        component: () => import("../views/onlineDes/onlineDes.vue"),
      },
      {
        path: "postList",
        name: "postList",
        component: () => import("../views/postList/postList.vue"),
      },
      {
        path: "onlineInterView",
        name: "onlineInterView",
        component: () => import("../views/onlineInterView/onlineInterView.vue"),
      },
      {
        path: "colorWarehouse",
        name: "colorWarehouse",
        component: () => import("../views/ShareCustomers/colorWarehouse"),
      },
      {
        path: "phoneModeList",
        name: "phoneModeList",
        component: () => import("../views/phoneModeList/phoneModeList"),
      },
      {
        path: "BackTone",
        name: "BackTone",
        component: () => import("../views/BackTone/BackTone"),
      },
      {
        path: "ShareCustomersDepartment",
        name: "ShareCustomersDepartment",
        component: () => import("../views/ShareCustomers/ShareCustomersDepartment"),
      },
      {
        path: "ShareCustomersUser",
        name: "ShareCustomersUser",
        component: () => import("../views/ShareCustomers/ShareCustomersUser"),
      },
      {
        path: "ShareCustomersTeacher",
        name: "ShareCustomersTeacher",
        component: () => import("../views/ShareCustomers/ShareCustomersTeacher"),
      },
      {
        path: "ztxcTs",
        name: "ztxcTs",
        component: () => import("../views/ShareCustomers/ztxcTs"),
      },
      {
        path: "expenseAccountMK",
        name: "expenseAccountMK",
        component: () => import("../views/ShareCustomers/expenseAccountMK"),
      },
      {
        path: "expenseSupplier",
        name: "expenseSupplier",
        component: () => import("../views/ShareCustomers/expenseSupplier"),
      },
      {
        path: "corporateAssets",
        name: "corporateAssets",
        component: () => import("../views/Roster/corporateAssets"),
      },
      {
        path: "manualRecord",
        name: "manualRecord",
        component: () => import("../views/manual/manualRecord"),
      },
      {
        path: "AssetsRoster",
        name: "AssetsRoster",
        component: () => import("../views/assetsRoster/AssetsRoster"),
      },
       {
        path: "AssetsRoster",
        name: "AssetsRoster",
        component: () => import("../views/assetsRoster/AssetsRoster"),
      },
       {
        path: "interviewCheckInRecord",
        name: "interviewCheckInRecord",
        component: () => import("../views/interviewCheckInRecord/interviewCheckInRecord"),
      },
      {
        path: "jobPost",
        name: "jobPost",
        component: () => import("../views/jobPost/jobPost"),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
